import React, { useEffect, useState } from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { PardotFormType } from '@src/Application/Types/ComponentTypes'

import { Body, Box, Header, ImageWrapper, SubTitle, Title, Wrapper } from './PardotForm.styled'
import { handleIframeHeight } from './utils'

export const PardotForm = ({
    pardotFormTitle,
    subtitle,
    image,
    pardotURL,
    imageAnimation,
}: PardotFormType): JSX.Element => {
    const [height, setHeight] = useState(0)

    useEffect(() => {
        window.addEventListener('message', handleIframeHeight(setHeight))

        return () => {
            window.removeEventListener('message', handleIframeHeight(setHeight))
        }
    }, [])

    return (
        <Wrapper>
            <Box>
                <Header>
                    <Grid container>
                        <Grid item xs={12} md={image ? 8 : 12}>
                            <Title>{pardotFormTitle}</Title>
                            {subtitle && <SubTitle>{subtitle}</SubTitle>}
                        </Grid>
                        {image && (
                            <Grid item xs={12} md={4} container alignItems="end" justifyContent="end">
                                <ImageWrapper>
                                    <Image image={image} imageAnimation={imageAnimation} />
                                </ImageWrapper>
                            </Grid>
                        )}
                    </Grid>
                </Header>
                <Body>
                    <iframe src={pardotURL} title="contact pardot form" height={`${height}px`} width="100%" />
                </Body>
            </Box>
        </Wrapper>
    )
}
